import { Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import KenCardWithoutpadding from '../../global_components/KenCard/KenCard2';
import KenGrid from '../../global_components/KenGrid';
import Filters from '../../Components/Filters/Filters';
import {
  getComponentScoreByComponentId,
  getCourseEvaluationSubcomponentByComponentId,
} from '../../Utils/apiServices';
import { useLocation } from 'react-router-dom';
import { Newtable } from '../../Components/NewTablecomponents/NewTablecomponent';
import KenLoader from '../../Components/KenLoader';
import { AiFillCaretRight, AiFillCaretDown } from 'react-icons/ai';

export default function StudentsMarksByComponent() {
  const search = useLocation().search;
  const id = new URLSearchParams(search).get('id');
  const [loading, setLoading] = React.useState(false);
  const [componentId, setcomponentId] = React.useState('');
  const [scoreData, setScoreData] = useState([]);

  const columns = [
    {
      // Make an expander cell
      Header: () => null, // No header
      id: 'expander', // It needs an ID
      Cell: ({ row }) => (
        // Use Cell to render an expander for each row.
        // We can use the getToggleRowExpandedProps prop-getter
        // to build the expander.
        <span {...row.getToggleRowExpandedProps()}>
          {row.isExpanded ? <AiFillCaretDown /> : <AiFillCaretRight />}
        </span>
      ),
    },
    {
      Header: 'Student',
      accessor: 'studentName',
      disableGlobalFilter: false,
    },
    {
      Header: 'Max Marks',
      accessor: 'maximumMarks',
      disableGlobalFilter: false,
    },
    {
      Header: 'Marks Obtained',
      accessor: 'marksObtained',
      disableGlobalFilter: false,
    },
    {
      Header: 'Course Marks',
      accessor: 'marksInCourse',
      disableGlobalFilter: false,
    },
  ];
  const data = [
    {
      contactName: 'Pranav',
      maxMarks: 10,
      marksObtained: 9,
      marksInCourse: 4.5,
    },
    {
      contactName: 'Prashanth',
      maxMarks: 10,
      marksObtained: 9,
      marksInCourse: 4.5,
    },
  ];

  const componentData = {
    name: '',
  };

  useEffect(() => {
    if (id || componentId) {
      let idS = id || componentId;
      console.log('test', idS);
      setLoading(true);
      getComponentScoreByComponentId(idS)
        .then((res) => {
          setScoreData(res);
          setLoading(false);
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [id, componentId]);

  const handleCourseEvaluation = (e) => {
    setcomponentId(e.target.value);
  };
  const renderComponents = React.useCallback(
    ({ row }) => <ComponentsMarksTable data={row.original} />,
    []
  );
  return (
    <>
      <Typography variant="h6">
        Students By Component <b>{componentData.name}</b>
      </Typography>
      {loading && <KenLoader />}

      {id ? null : (
        <Filters
          term={true}
          CourseVersion={true}
          courseoff={true}
          CourseEvaluationComponent={true}
          handleCourseEvaluation={handleCourseEvaluation}
        />
      )}

      <KenCardWithoutpadding>
        <Newtable
          columns={columns}
          data={scoreData}
          renderComponents={renderComponents}
        />
      </KenCardWithoutpadding>
    </>
  );
}

const ComponentsMarksTable = ({ data }) => {
  const columns = React.useMemo(
    () => [
      // {
      //   Header: 'Student',
      //   accessor: 'studentName',
      // },
      {
        Header: 'Max Marks',
        accessor: 'maximumMarks',
      },
      {
        Header: 'Marks Obtained',
        accessor: 'marksObtained',
      },
      {
        Header: 'Marks In course',
        accessor: 'marksInCourse',
      },
    ],
    []
  );

  return (
    <>
      {data?.subCompList?.length > 0 ? (
        <Newtable columns={columns} data={data?.subCompList}></Newtable>
      ) : (
        <p>No Data</p>
      )}
    </>
  );
};
